// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__IyEyc","column":"style_column__cAsI8","row":"style_row__3L6Df"};